import { axiosInstance } from "./AxiosDefaults";
import { citiesRoute } from "../constants/ApiRoutes";
import { City } from "../models/City";

export const getAllCities = (): Promise<any> => {
  return axiosInstance.get(citiesRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createCity = (payload: Partial<City>): Promise<any> => {
  return axiosInstance.post(citiesRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneCity = (id: string, payload: Partial<City>): Promise<any> => {
  return axiosInstance.put(`${citiesRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
